import React from 'react';
import { SectionReveal } from '../SectionReveal';
import { TestimonialCard } from '../TestimonialCard';
import type { Testimonial } from '../../data/content';
interface TestimonialsProps {
  heading: string;
  items: Testimonial[];
}
export function Testimonials({
  heading,
  items
}: TestimonialsProps) {
  return <section className="relative w-full bg-carbon-2" aria-labelledby={`tst-${heading}`} data-id="element-174">
      <div className="h-1 w-full" style={{
      background: 'linear-gradient(90deg, #FF6B00 0%, #0A0A0A 100%)'
    }} aria-hidden="true" data-id="element-175" />
      <SectionReveal className="mx-auto max-w-6xl px-5 py-16 sm:py-20" data-id="element-176">
        <h2 id={`tst-${heading}`} className="mb-10 text-center font-heading text-2xl font-bold uppercase tracking-tight text-soft sm:text-3xl" data-id="element-177">
          💬 {heading}
        </h2>
        {/* Mobile: horizontal slider. Desktop: grid */}
        <div className="no-scrollbar flex snap-x snap-mandatory gap-4 overflow-x-auto pb-2 md:grid md:grid-cols-3 md:overflow-visible" data-id="element-178">
          {items.map(t => <div key={t.initials} className="w-[85%] flex-none snap-center md:w-auto" data-id="element-179">
              <TestimonialCard t={t} data-id="element-180" />
            </div>)}
        </div>
      </SectionReveal>
    </section>;
}